import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { Chart } from 'chart.js';
import { Settings } from '../../app.settings.model';
import { AppSettings } from '../../app.settings';
@Component({
  selector: 'app-chart-pie',
  templateUrl: './chart-pie.component.html',
  styleUrls: ['./chart-pie.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChartPieComponent implements OnInit, AfterViewInit {
  @ViewChild('PieChartID')
  chartID: ElementRef;
  @Input('chartType')
  chartType: string;
  @Input('chartIsDoughnut')
  chartIsDoughnut: boolean = true;
  @Input('labels')
  labels: any[];
  @Input('chartData')
  chartData: any[];
  @Input('backgroundColors')
  backgroundColors: any[] = [
    '#86c27c',
    '#ff8357',
    '#3d1b68',
    '#fedd57',
    '#9b6eff',
    '#57c4de',
    '#e52e2d',
    '#eaaeae',
    '#b65bf7',
    '#313131',
    '#0aa9c6'
  ];
  @Input('position')
  position: string = 'bottom';
  public chartPie: any;
  protected settings: Settings;
  constructor(private appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    // const myChart = new Chart(this.id.nativeElement, {
    //   type: 'bar',
    //   data: {
    //     labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
    //     datasets: [
    //       {
    //         label: '# of Votes',
    //         data: this.chartData,
    //         backgroundColor: [
    //           'rgba(255, 99, 132, 0.2)',
    //           'rgba(54, 162, 235, 0.2)',
    //           'rgba(255, 206, 86, 0.2)',
    //           'rgba(75, 192, 192, 0.2)',
    //           'rgba(153, 102, 255, 0.2)',
    //           'rgba(255, 159, 64, 0.2)'
    //         ],
    //         borderColor: [
    //           'rgba(255,99,132,1)',
    //           'rgba(54, 162, 235, 1)',
    //           'rgba(255, 206, 86, 1)',
    //           'rgba(75, 192, 192, 1)',
    //           'rgba(153, 102, 255, 1)',
    //           'rgba(255, 159, 64, 1)'
    //         ],
    //         borderWidth: 1
    //       }
    //     ]
    //   },
    //   options: {
    //     scales: {
    //       yAxes: [
    //         {
    //           ticks: {
    //             beginAtZero: true
    //           }
    //         }
    //       ]
    //     }
    //   }
    // });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.chartLoader();
    }, 0);
  }

  chartLoader(): void {
    this.chartPie = new Chart(this.chartID.nativeElement, {
      type: this.chartType, // pie , line ,'doughnut' ....
      data: {
        labels: this.labels,
        datasets: [
          {
            label: null,
            data: this.chartData,
            backgroundColor: this.backgroundColors,
            borderWidth: 0
          }
        ]
      },
      options: {
        responsive: true,
        legend: {
          position: this.position
        },
        animation: {
          animateScale: true,
          defaultColor: 'rgba(152, 152, 152, 0.5)',
          onComplete: function(ctx) {
            ctx.chart.ctx.shadowColor = 'rgba(152, 152, 152, 0.5)';
            ctx.chart.ctx.shadowBlur = 10;
            ctx.chart.ctx.shadowOffsetX = 2;
            ctx.chart.ctx.shadowOffsetY = 2;
          }
        }
      }
    }); // Must be List // Type is string
  }
  public chartUpdate() {
    this.chartPie.resize();
    this.chartPie.update({
      duration: 800,
      lazy: true,
      easing: 'easeOutBounce'
    });
  }
}
